import * as libraryEvents from "./libraryEvents";

// merge all types of real time notification events
// return an array of values
const eventTypes = Object.values({ ...libraryEvents });

export default eventTypes;
